import React from 'react';
import { InternalSettings as EasSettings } from '@eas/common-web';

export function InternalSettings() {
  return <EasSettings />;
}
